import React, {useState, useEffect} from 'react'
import {useParams} from "react-router-dom"
import {useQuery} from "react-query"
import {toast} from "react-toastify"
import {errorMessage} from "utils/utils"
import useAuth from "auth/useAuth"
import useRescue from "hooks/useRescue"
import useValues from "hooks/useValues"
import RescueNote from "./RescueNote"
import RescueArea from "./RescueArea"
import SubjectSection from "./Section.01.Subject"
import ResortSection from "./Section.02.Resort"
import InjurySection from "./Section.03.Injury"
import TimelineSection from "./Section.04.Timeline"
import LocationSection from "./Section.05.Location"
import WeatherSection from "./Section.06.Weather"
import AidSection from "./Section.07.Aid"
import EndSection from "./Section.08.End"
import RescuersSection from "./Section.09.Rescuers"
import FieldsSection from "./Section.10.Fields"
import DescriptionSection from "./Section.11.Description"
import RescueButtons from "./RescueButtons"
import RescueAttachments from "./RescueAttachments"
import RescueDebug from "./RescueDebug"
import RescueOld from "./RescueOld"
import Existing from "./Existing"
import Submit from "./Submit"
import Spinner from "components/Spinner"
import "./RescuePage.css"


export default function RescuePage() {
    
    const [id, setId] = useState(useParams().id)
    const {auth, API, admin, ready} = useAuth()
    const {data: values} = useValues("rescue")
    const rescue = useRescue(id)
    const [existing, setExisting] = useState(null) // null = not yet determined
    const [submitting, setSubmitting] = useState(false)
    const [submitData, setSubmitData] = useState()

    // Determine if we should show the "existing" dialog after data loads
    useEffect(() => {
        if (!rescue.ready || existing !== null) return
        if (rescue.dirty) {
            setExisting(true)
        } else {
            // No meaningful changes - clear localStorage and continue fresh
            rescue.clear()
            setExisting(false)
        }
    }, [rescue.ready])

    const edit = () => {
        setSubmitting(false)
    }
    
    const submit = () => {
        const toaster = toast.loading("Da vidimo...")
        rescue.save(response => {
            setSubmitData(response.data)
            setSubmitting(true)
            setId(response.data.rescue.id)
            // rescue.refetch()
            toast.dismiss(toaster)
        }, response => {
            console.log("OSAM", response)
            toast.update(toaster, {render: `Neka greška [8]: ${errorMessage(response)}`, type: "error", isLoading: false, autoClose: 2500})        
        })
    }


    // Handle query errors (network, API, corrupted localStorage)
    if (rescue.isError) {
        return <section className="white shadow" id="rescue-edit">
            <h2 style={{color: '#c0392b'}}>Greška pri učitavanju</h2>
            <p>Došlo je do greške pri učitavanju povredne liste. Molimo vas da slikate ekran i pošaljete administratoru.</p>
            <pre style={{background: '#f8f8f8', padding: '1em', borderRadius: 8, fontSize: '0.85em', whiteSpace: 'pre-wrap', wordBreak: 'break-word'}}>
                {rescue.error?.message || String(rescue.error)}
            </pre>
            <button className="btn btn-primary" onClick={() => rescue.reload()}>Pokušaj ponovo</button>
        </section>
    }

    // Wait until we determine if there's existing data to continue
    if (existing === null) return <Spinner center/>

    if (existing) return <Existing rescue={rescue} setExisting={setExisting}/>

    // Handle version=1 (imported from old database) — read-only view
    if (rescue.rescue?.version === 1) {
        return <RescueOld rescue={rescue}/>
    }

    // Handle blurred (no view permission) state
    if (rescue.rescue?.blurred) {
        return <section className="white shadow" id="rescue-edit">
            <h1>Povredna lista {rescue.rescue.short_id}</h1>
            <p style={{padding: '2em', textAlign: 'center', opacity: 0.6}}>
                Nemate pristup ovoj povrednoj listi.
            </p>
        </section>
    }

    return <>
        <section className="white shadow" id="rescue-edit">
            {id ? <h1>
                <span>Povredna lista</span>
                <span>{rescue.rescue?.short_id} &#x2022; {rescue.getSubjectName()}</span>            
            </h1> : <h1>Nova povredna lista</h1>}
                    
            {!submitting && <>
                
                <div id="above">
                    <RescueNote rescue={rescue}/>
                    <RescueAttachments rescue={rescue}/>                    
                </div>
                
                <RescueArea rescue={rescue}/>

                <ul className="accordion">
                    <SubjectSection rescue={rescue}/>
                    <ResortSection rescue={rescue} values={values}/>
                    <InjurySection rescue={rescue} values={values}/>
                    <TimelineSection rescue={rescue} values={values}/>
                    <LocationSection rescue={rescue}/>
                    <WeatherSection rescue={rescue} values={values}/>
                    <AidSection rescue={rescue} values={values}/>
                    <EndSection rescue={rescue} values={values}/>
                    <RescuersSection rescue={rescue}/>
                    {rescue.rescue?.area === 'OPU' && <FieldsSection rescue={rescue}/>}
                    <DescriptionSection rescue={rescue} values={values}/>
            	</ul>

            	<RescueButtons rescue={rescue} submit={submit}/>
            </>}
            
            {submitting && <Submit rescue={rescue} data={submitData} edit={edit}/>}                
        </section>
        {admin && <RescueDebug rescue={rescue}/>}
    </>

}